import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ef6503c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "停止済みタレント一覧", -1))
const _hoisted_2 = { class: "mt20" }
const _hoisted_3 = { class: "deleted-link" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("タレント一覧へ")

import DeletedUserList from '@/components/users/DeletedUserList.vue'
  import UserRestoreDialog from '@/components/users/UserRestoreDialog.vue'
  import { useDeletedUserList } from '@/logic/users/UserListLogic'
  import { useUserRestoreDialogView } from '@/logic/users/UserRestoreDialogLogic'

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const {
    loading,
    userList,
    load,
  } = useDeletedUserList();

  const {
    visible: visibleUserRestoreDialog,
    restoreUser,
    handleClick: handleClickUserRestoreDialog,
  } = useUserRestoreDialogView();

  const handleSubmitUserRestoreDialog = () => {
    visibleUserRestoreDialog.value = false;
    load();
  };

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "container" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_card, { class: "container__card" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createVNode(UserRestoreDialog, {
              modelValue: _unref(visibleUserRestoreDialog),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visibleUserRestoreDialog) ? (visibleUserRestoreDialog).value = $event : null)),
              onSubmit: handleSubmitUserRestoreDialog,
              user: _unref(restoreUser)
            }, null, 8, ["modelValue", "user"]),
            _withDirectives(_createVNode(DeletedUserList, {
              users: _unref(userList),
              "onClick:restore": _unref(handleClickUserRestoreDialog)
            }, null, 8, ["users", "onClick:restore"]), [
              [_directive_loading, _unref(loading)]
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                to: "/users",
                class: "button-link"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, null, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})